<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست ورود کاربران
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="success"
        class="mb-1 float-right"
        target="_blank"
        :href="exportExcel"
      >
        <feather-icon
          icon="FileTextIcon"
          class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.filter-box
        variant="outline-primary"
        class="mb-1"
      >
        <feather-icon
          icon="FilterIcon"
          class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
        id="filter-box"
        class="mb-2"
      >
        <b-card class="border mb-0">
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label>نام:</label>
                <b-form-input
                  v-model="search.name"
                  placeholder="نام را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label>موبایل:</label>
                <b-form-input
                  v-model="search.mobile"
                  placeholder="موبایل را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label>نام کاربری:</label>
                <b-form-input
                  v-model="search.username"
                  placeholder="نام کاربری را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                  label="از تاریخ"
                  label-for="birthdayFrom"
              >
                <date-picker
                    v-model="search.createdFrom"
                    type="date"
                    display-format="jDD jMMMM jYYYY"
                    format="YYYY-MM-DD"
                    :max="search.createdTo"
                    simple
                    clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                  label="تا تاریخ"
                  label-for="birthdayTo"
              >
                <date-picker
                    v-model="search.createdTo"
                    type="date"
                    display-format="jDD jMMMM jYYYY"
                    format="YYYY-MM-DD"
                    simple
                    :min="search.createdFrom"
                    clearable
                />

              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              @click="advanceSearch"
            >
              اعمال جستجو
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              @click="clearSearch"
            >
              حذف فیلترها
            </b-button>
          </div>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(roles)="data">
              <b-badge
                v-for="(role, index) in data.value"
                :key="index"
                variant="light-info"
                class="ml-1"
              >{{
                role
              }}
              </b-badge>

            </template>
            <template #cell(isActive)="data">
              <b-avatar
                  :id="`user-row-${data.item.id}`"
                  size="32"
                  :variant="data.value ? 'light-success': 'light-danger'"
              >
                <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                />
              </b-avatar>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                text="عملیات"
                variant="outline-primary"
              >
                <b-dropdown-item :to="{name: 'Users_Update', params:{id: data.item.id}}">
                  <feather-icon
                    icon="EditIcon"
                    class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
                <b-dropdown-item @click="deleteUser(data.item.id)">
                  <feather-icon
                    icon="XSquareIcon"
                    class="text-danger"
                  />
                  حذف
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle, BAvatar,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { doubleRaf, queryString } from '@/libs/utils'
import { computed } from '@vue/composition-api'
import { debounce } from '@/libs/debounce'

export default {
  name: 'UsersList',
  components: {
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'user.name',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'createdDate',
          label: 'تاریخ ورود',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      search: {},
      onExportProgress: false,
    }
  },

  computed:{
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}user/login-logs?export-excel=1&${query}`
    }
  },
  methods: {
    getUsersList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true

      this.$http.get('user/login-logs', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.data
            this.currentPage = data.meta.current_page
            this.totalRows = data.meta.total
            this.perPage = data.meta.per_page
          } else {
            this.$bvToast.toast('در دریافت لیست  خطایی رخ داده', {
              title: 'حطا',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
        .then(() => {
          this.getUsersList()
        })
        .catch(() => {
        })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
        .then(() => {
          this.getUsersList()
        })
        .catch(() => {
        })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    onSearch(search, loading) {
      if (search.length){
        loading(true)
        this.searchUser(loading, search, this);
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    },400),
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
  },
  mounted() {
    this.getUsersList()
    this.setSearchData()
  },

  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Users_login_logs',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getUsersList()
      }
    },
  },
}
</script>

<style>

</style>
